export default __webpack_public_path__ + "static/media/404.e9e2bc7e.svg";